import React, {Component, useContext, useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import {Col, Container, Row} from 'react-grid-system'
import {DimensionContext} from "../../Components/App/dimension-context";
import styles from './blog.module.scss';
import Shimmer from './imageShim.svg';
import ReactHtmlParser from "react-html-parser";

import loadable from "@loadable/component";
import {SSRContext} from "../../Components/App/ssr-context";

const Head = loadable(() => import("./head"));

function renderSinglePost({id, title, slug, excerpt, img: {alt, src, className = '', ...imgProps}}, type) {
    return <Col key={id} className={styles.blogCol} md={4} sm={12} xs={12}>
        <Link to={`/${type}/${id}/${slug}`} title={title}>
            <div className={styles.label}><label>{title}</label></div>
            <img title={title} aria-describedby={excerpt} alt={alt} src={src}
                 className={styles.postImage + ` ${className}`} {...imgProps}/>
        </Link>
    </Col>
}

function renderRows(row, i, type) {
    return <Row key={i} className={styles.blogRow}>
        {row.map((post) => renderSinglePost({...post}, type))}
    </Row>
}

function renderLoading() {
    const posts = [[]]
    for (let i = 0; i < 3; i++) {
        posts[i] = [];
        for (let j = 0; j < 3; j++) {
            posts[i][j] = {id: i + j};
        }
    }

    return posts.map((row, i) => <Row key={i} className={styles.blogRow}>
        {row.map((post) => <Col key={post.id} className={styles.blogCol} md={4} sm={12} xs={12}>
            <div className={styles.label}><label>loading</label></div>
            <img alt={'Loading'} src={Shimmer}
                 className={`${styles.postImage} blink`}/>
        </Col>)}
    </Row>)
}

function renderPosts(raw, type) {
    const posts = [];
    const rowSize = 3;
    for (let i = 0; i < raw.length; i += rowSize)
        posts.push(raw.slice(i, i + rowSize))
    return posts.map((row, i) => renderRows(row, i, type))
}

export default function Blog(props) {
    const [posts, setPosts] = useState([])
    const [loading, toggleLoading] = useState(true)
    const style = useContext(DimensionContext);
    const {isSSR, toggleSSR} = useContext(SSRContext);
    const _isMounted = useRef(true);
    const type = useRef("");
    const filter = useRef("");

    async function getPosts(page) {
        try {
            if (!loading) toggleLoading(true);
            let url = `https://blog.omid.navy/wp-json/wp/v2/${type.current}?`;
            if (type.current === "posts")
                url += `${filter.current}_fields=yoast_head,id,title,slug,excerpt,_links.wp:featuredmedia&_embed`;
            else if (type.current === "categories" || type.current === "tags")
                url += "_fields=yoast_head,id,name,slug,description,count";
            else if (type.current === "search") url += `search=${filter.current}&_fields=yoast_head,id,title,slug,excerpt,_links.wp:featuredmedia&_embed&`
            url += `&per_page=18&page=${page}`;

            const response = await fetch(url);
            const posts = await response.json();
            let items = [];
            if (type.current === "posts") items = posts.map(post => {
                return {
                    id: post.id,
                    title: ReactHtmlParser(post.title.rendered),
                    excerpt: post.excerpt.rendered.replace(/(<([^>]+)>)|(\r?\n|\r)/gi, ""),
                    slug: post.slug,
                    img: {
                        alt: post._embedded['wp:featuredmedia'][0].alt_text,
                        src: post._embedded['wp:featuredmedia'][0].source_url,
                    }
                }
            })
            if (type.current === "categories" || type.current === "tags") items = posts.map(post => {
                return {
                    id: post.id,
                    title: post.name,
                    excerpt: post.description.replace(/(<([^>]+)>)|(\r?\n|\r)/gi, ""),
                    slug: post.slug,
                    img: {
                        alt: post.slug,
                        src: `/content/${type.current}/${post.slug}.svg`,
                    }
                }
            })
            if (!_isMounted.current) return;
            toggleLoading(false)
            setPosts(items)

        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        const {match} = props;
        const path = match.path.replace(/\//g, '')
        _isMounted.current = true;
        if (path === 'blog') {
            type.current = "posts";
            filter.current = "";
            if (props.location.search.length > 0 && props.location.search.includes("?search=")) {
                filter.current = props.location.search.replace('?', '') + '&';
            }
        } else if (path === 'tags:id:tag') {
            type.current = "posts"
            filter.current = `tags=${match.params.id}&`
        } else if (path === 'categories:id:category') {
            type.current = "posts"
            filter.current = `categories=${match.params.id}&`
        } else if (path === 'categories') {
            type.current = "categories"
        } else if (path === 'tags') {
            type.current = "tags"
        }

        getPosts(1)
        return () => {
            _isMounted.current = false;
            if (isSSR) toggleSSR();
        }

    }, [])

    return <>
        {isSSR === false && <Head head={type.current}/>}
        <main className={`${styles.blog} noselect`} style={{height: style.height}}>
            <Container>
                {loading ? renderLoading() : renderPosts(posts,type.current)}
            </Container>
        </main>
    </>

}

